import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79006820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-file-container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "image-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "delimiter" }, "-", -1))
const _hoisted_6 = ["href", "title"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Lien vers le fichier audio")
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('../assets/headphones-icon.svg')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.audioPartLabel), 1),
      _hoisted_5,
      _createElementVNode("a", {
        href: _ctx.audioPath,
        target: "_blank",
        title: 'Lien externe vers le fichier audio de la partie ' + _ctx.audioPartLabel
      }, [
        _hoisted_7,
        _createElementVNode("img", {
          class: "external-link-icon",
          src: require('../assets/external-link-icon.svg')
        }, null, 8, _hoisted_8)
      ], 8, _hoisted_6)
    ]),
    _createElementVNode("audio", {
      controls: "",
      src: _ctx.audioPath
    }, null, 8, _hoisted_9)
  ]))
}